import {
  MaterialStorage,
  useCurrentMaterialStorages,
  isStorageWithMaterialGuard
} from '@domain/material-storage'
import {useUpmPlantContext} from '@hconnect/upm'

const selector = (storages: MaterialStorage[]) => {
  const storagesTypesWithMaterial = storages
    .filter(isStorageWithMaterialGuard)
    .map((storage) => storage.materialType)

  return [...new Set(storagesTypesWithMaterial)]
}

export const useCurrentStoredMaterialTypesQuery = () => {
  const {plantId: plantCode} = useUpmPlantContext()
  return useCurrentMaterialStorages({
    plantId: plantCode,
    options: {select: selector, throwOnError: true}
  })
}
